//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
// import './style.scss';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Check } from 'src/onboarding/components/ui/check/Check';
import { Option } from 'src/onboarding/components/ui/check/Option';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const typicalLunch = useStore((state) => state.typicalLunch);
  const setTypicalLunch = useStore((state) => state.setTypicalLunch);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.typicalLunch.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={typicalLunch}
          onChange={(value) => {
            setTypicalLunch(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'typical-lunch',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'I tend to eat sandwiches or wraps'}>
            {t('onboarding.typicalLunch.options.sandwiches')}
          </Option>
          <Option value={'I tend to eat soups or salads'}>
            {t('onboarding.typicalLunch.options.salads')}
          </Option>
          <Option value={'I tend to eat fast food'}>
            {t('onboarding.typicalLunch.options.fastFood')}
          </Option>
          <Option value={'Other'}>{t('onboarding.typicalLunch.options.other')}</Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
